import styled from 'styled-components';

//   margin: 8px 4px 8px 8px;
export const Wrapper = styled.div`
  margin: 0 ${({ theme }) => theme.spacing.x1};
`;
